"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPlugin = void 0;
var __1 = require("../");
// /!\ black magic warning : dynamic leaflet import
// to avoid importing it twice in the page
var L;
var markerIcon;
if (window.L == undefined) {
    Promise.resolve().then(function () { return __importStar(require("leaflet")); }).then(function (theLeaflet) {
        L = theLeaflet;
        window.L = L;
        Promise.resolve().then(function () { return __importStar(require("leaflet.markercluster")); });
        markerIcon = L.icon({
            iconUrl: require("leaflet/dist/images/marker-icon.png"),
            shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        });
    });
}
else {
    L = window.L;
    Promise.resolve().then(function () { return __importStar(require("leaflet.markercluster")); });
    markerIcon = L.icon({
        iconUrl: require("leaflet/dist/images/marker-icon.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
}
var wktParsing_1 = require("./wktParsing");
// CSS is required otherwise tiles are messed up
require("leaflet/dist/leaflet.css");
require("leaflet.markercluster/dist/MarkerCluster.css");
require("leaflet.markercluster/dist/MarkerCluster.Default.css");
var TableXResults_1 = require("../TableXResults");
var MapPlugin = /** @class */ (function () {
    function MapPlugin(yasr) {
        this.priority = 5; // priority for sorting the plugins in yasr
        this.mapEL = null; //HTMLElement of the map
        this.warnEL = null; //HTMLElement of Warning message if results with no geo coordinates.
        this.map = null;
        this.layerGroups = {}; // group all polygons with sparql var name as key
        this.controlLayers = null; // responsible for filterable layers on the map
        this.colorsUsed = []; // used to color the polygons
        this.layers = []; // contains all layers (Marker | Polygon)
        this.hideFromSelection = false;
        this.label = "Map";
        this.haveResultWithoutGeo = 0;
        this.sparnaturalQuery = null;
        this.layerGroupsLabels = [];
        this.yasr = yasr;
        // merge options when set by client
        if (MapPlugin.defaults.markerOptions)
            L.Marker.mergeOptions(MapPlugin.defaults.markerOptions);
        if (MapPlugin.defaults.polylineOptions)
            L.Marker.mergeOptions(MapPlugin.defaults.polylineOptions);
        this.config = MapPlugin.defaults;
        this.markerCluster = L.markerClusterGroup();
        //this.controlLayers = L.control.layers()
        /*this.yasr?.rootEl.addEventListener("sparnaturalQueryChange", (e) => {
                this.initDrawSearchAreas() ;
            });*/
    }
    // Map plugin can handle results in the form of geosparql wktLiterals
    // http://schemas.opengis.net/geosparql/1.0/geosparql_vocab_all.rdf#wktLiteral
    MapPlugin.prototype.canHandleResults = function () {
        var _this = this;
        var tableXResults = new TableXResults_1.TableXResults(this.yasr.results);
        var have_geo = false;
        this.haveResultWithoutGeo = 0;
        if (tableXResults && tableXResults.getBindings().length > 0) {
            tableXResults.getBindings().some(function (row) {
                // if a cell contains a geosparql value
                if (_this.getGeosparqlValue(row)) {
                    have_geo = true;
                }
                else {
                    _this.haveResultWithoutGeo++;
                }
            });
        }
        // also see cases where we have a latitude and longitude columns
        if (!have_geo) {
            if (this.sparnaturalQuery &&
                MapPlugin.getLatitudeColumn(tableXResults, this.sparnaturalQuery) &&
                MapPlugin.getLongitudeColumn(tableXResults, this.sparnaturalQuery)) {
                return true;
            }
        }
        return have_geo;
    };
    MapPlugin.getLatitudeColumn = function (tableXResults, query) {
        if (!query)
            return;
        // analyze the predicate of each column
        for (var i in tableXResults.getVariables()) {
            var varName = tableXResults.getVariables()[i];
            var property = MapPlugin.getVariablePredicateRec(query, varName);
            if (
            // property == "https://schema.org/latitude"
            // ||
            // property == "http://www.w3.org/2003/01/geo/wgs84_pos#lat"
            property &&
                (property === null || property === void 0 ? void 0 : property.toLowerCase().indexOf("lat")) > -1) {
                return varName;
            }
        }
    };
    MapPlugin.getLongitudeColumn = function (tableXResults, query) {
        if (!query)
            return;
        // analyze the predicate of each column
        for (var i in tableXResults.getVariables()) {
            var varName = tableXResults.getVariables()[i];
            var property = MapPlugin.getVariablePredicateRec(query, varName);
            if (
            // property == "https://schema.org/longitude"
            // ||
            // property == "http://www.w3.org/2003/01/geo/wgs84_pos#long"
            property &&
                (property === null || property === void 0 ? void 0 : property.toLowerCase().indexOf("long")) > -1) {
                return varName;
            }
        }
    };
    MapPlugin.getVariablePredicateRec = function (query, varName) {
        var branchWithVar = MapPlugin.findBranchWithObjectVar(query, varName);
        if (branchWithVar) {
            return branchWithVar.line.p;
        }
    };
    MapPlugin.findBranchWithObjectVar = function (query, varName) {
        var _a;
        if (query["branches"]) {
            for (var index = 0; index < query.branches.length; index++) {
                var branch = query.branches[index];
                var result = MapPlugin.findBranchWithObjectVar(branch, varName);
                if (result)
                    return result;
            }
        }
        else {
            if (query.line.o == varName) {
                return query;
            }
            else {
                for (var index = 0; index < ((_a = query.children) === null || _a === void 0 ? void 0 : _a.length); index++) {
                    var branch = query.children[index];
                    var result = MapPlugin.findBranchWithObjectVar(branch, varName);
                    if (result)
                        return result;
                }
            }
        }
    };
    /**
     * @param row a binding set
     * @returns an array of GeoCell objects containing the literal value and column index, for each column having a geo datatype
     */
    MapPlugin.prototype.getGeosparqlValue = function (row) {
        //console.log("getGeosparqlValue")
        var geoLiterals = [];
        for (var key in row) {
            var cell = row[key];
            if (this.isBindingValue(cell)) {
                if (this.isGeoValue(cell)) {
                    // cell contains a geoliteral
                    geoLiterals.push({ cellValue: cell, variable: key });
                }
                else if (this.sparnaturalQuery) {
                    var property = MapPlugin.getVariablePredicateRec(this.sparnaturalQuery, key);
                    //console.log(property);
                    if (property && property.toLowerCase().indexOf("lat") > -1) {
                        // find the longitude key
                        var longKey = undefined;
                        for (var anotherKey in row) {
                            var anotherProperty = MapPlugin.getVariablePredicateRec(this.sparnaturalQuery, anotherKey);
                            if (anotherProperty &&
                                anotherProperty.toLowerCase().indexOf("long") > -1) {
                                console.log("found longKey" + longKey);
                                longKey = anotherKey;
                            }
                            if (longKey) {
                                // we fake a wktLiteral
                                geoLiterals.push({
                                    cellValue: {
                                        value: "POINT(" + row[longKey].value + " " + cell.value + ")",
                                        type: "literal",
                                        datatype: "http://www.opengis.net/ont/geosparql#wktLiteral",
                                    },
                                    variable: key,
                                });
                            }
                        }
                    }
                }
            }
        }
        if (geoLiterals.length > 0)
            return geoLiterals;
        return null;
    };
    MapPlugin.prototype.isGeoValue = function (cell) {
        var isGeoSparql = this.config.geoDataType.includes(cell.datatype);
        return isGeoSparql;
    };
    MapPlugin.prototype.draw = function (persistentConfig, runtimeConfig) {
        var _this = this;
        var _a, _b;
        this.results = new TableXResults_1.TableXResults(this.yasr.results);
        //if the resultset changed, then cleanup and rerender
        this.cleanUp();
        this.createMap();
        var geo_rows = {};
        this.layerGroupsLabels = Array();
        this.results.getBindings().forEach(function (row) {
            var geoCells = _this.parseGeoLiteral(row, _this.config.parsingFunction);
            // features are in this case either GeoJson Point or Polygons
            if (geoCells.length === 0) {
                return;
            }
            return geoCells.map(function (geoCell) {
                var _a, _b, _c, _d, _e, _f, _g;
                var popUpString = _this.createPopUpString(row);
                if (((_a = geoCell.parsedLit) === null || _a === void 0 ? void 0 : _a.type) === "Point")
                    _this.drawMarker(geoCell.parsedLit, geoCell.variable, popUpString);
                if (((_b = geoCell.parsedLit) === null || _b === void 0 ? void 0 : _b.type) === "Polygon") {
                    // compute Polygon area and store it
                    var area = _this.polygonArea((_c = geoCell.parsedLit) === null || _c === void 0 ? void 0 : _c.coordinates);
                    var rowObject = {
                        cellValue: geoCell.cellValue,
                        parsedLit: geoCell.parsedLit,
                        variable: geoCell.variable,
                        popUpString: popUpString,
                        area: area,
                    };
                    if (geo_rows[geoCell.variable] == undefined) {
                        geo_rows[geoCell.variable] = Array();
                    }
                    geo_rows[geoCell.variable].push(rowObject);
                }
                if (((_d = geoCell.parsedLit) === null || _d === void 0 ? void 0 : _d.type) === "MultiPolygon") {
                    // Store MultiPolygon as a single entry with total area
                    var totalArea = 0;
                    for (var _i = 0, _h = geoCell.parsedLit.coordinates; _i < _h.length; _i++) {
                        var polygonCoords = _h[_i];
                        totalArea += _this.polygonArea(polygonCoords);
                    }
                    var cols = (_e = _this.results) === null || _e === void 0 ? void 0 : _e.getVariables();
                    var rowObject = {
                        cellValue: geoCell.cellValue,
                        parsedLit: geoCell.parsedLit,
                        variable: geoCell.variable,
                        popUpString: popUpString,
                        area: totalArea,
                        colIndex: cols ? cols.indexOf(geoCell.variable) : 0,
                    };
                    if (geo_rows[geoCell.variable] == undefined) {
                        geo_rows[geoCell.variable] = Array();
                    }
                    geo_rows[geoCell.variable].push(rowObject);
                }
                if (((_f = geoCell.parsedLit) === null || _f === void 0 ? void 0 : _f.type) === "LineString")
                    _this.drawLineString(geoCell.parsedLit, geoCell.variable, popUpString);
                if (((_g = geoCell.parsedLit) === null || _g === void 0 ? void 0 : _g.type) === "MultiLineString")
                    _this.drawMultiLineString(geoCell.parsedLit, geoCell.variable, popUpString);
            });
        });
        // prepare the polygons to draw
        var layersRows = [];
        for (var key in geo_rows) {
            if (geo_rows[key]) {
                console.log(key);
                var colIndexArray = geo_rows[key];
                var sortedArray = colIndexArray.sort(function (n1, n2) {
                    if (n2.area && n1.area) {
                        return n2.area - n1.area;
                    }
                    else {
                        // will never happen
                        return -1;
                    }
                });
                geo_rows[key] = sortedArray;
                var it = 0;
                var max = 50;
                var itLayer = 0;
                layersRows = [];
                for (var ir = 0; ir < geo_rows[key].length; ir++) {
                    if (it > max - 1) {
                        it = 0;
                        itLayer++;
                    }
                    if (layersRows[itLayer] == undefined) {
                        layersRows[itLayer] = Array();
                    }
                    layersRows[itLayer].push(geo_rows[key][ir]);
                    it++;
                }
                var cols = (_a = this.results) === null || _a === void 0 ? void 0 : _a.getVariables();
                for (var ir = 0; ir < layersRows.length; ir++) {
                    var colIndex = layersRows[ir][0].colIndex;
                    var vName = cols[colIndex] + "_" + ir;
                    var last_item_key = layersRows[ir].length - 1;
                    var max_area = layersRows[ir][0].area + " km²";
                    var min_area = layersRows[ir][last_item_key].area + " km²";
                    this.layerGroupsLabels[vName] = min_area + " - " + max_area;
                }
            }
        }
        // draaaow the polygons
        for (var i = 0; i < layersRows.length; i++) {
            for (var ir = 0; ir < layersRows[i].length; ir++) {
                if (layersRows[i]) {
                    var data = layersRows[i][ir];
                    if (data.parsedLit.type === "MultiPolygon") {
                        // Decompose MultiPolygon into individual Polygons for drawing
                        for (var _i = 0, _c = data.parsedLit.coordinates; _i < _c.length; _i++) {
                            var polygonCoords = _c[_i];
                            var polygon = {
                                type: "Polygon",
                                coordinates: polygonCoords,
                            };
                            this.drawPoly(polygon, data.colIndex, data.popUpString, i);
                        }
                    }
                    else {
                        this.drawPoly(data.parsedLit, data.colIndex, data.popUpString, i);
                    }
                }
            }
        }
        // If the markers are clustered then draw the cluster now
        if (!this.map)
            throw Error("Couldn't find map element");
        // add all the layers created in addControlLayer
        var controlsLayersObjs = {};
        for (var _d = 0, _e = Object.entries(this.layerGroups); _d < _e.length; _d++) {
            var _f = _e[_d], k = _f[0], v = _f[1];
            var label = this.layerGroupsLabels[k];
            //this.controlLayers?.addOverlay(v,label)
            controlsLayersObjs[label] = v;
            v.addTo(this.map);
        }
        this.controlLayers = L.control.layers({}, controlsLayersObjs, {
            collapsed: false,
        });
        (_b = this.controlLayers) === null || _b === void 0 ? void 0 : _b.addTo(this.map);
        // add cluster of markers
        this.markerCluster.addTo(this.map);
        // when a popup gets rendered then attach listener
        this.map.on("popupopen", function (e) {
            var el = e.popup.getElement();
            if (!el)
                return;
            _this.addIriClickListener(el);
        });
        this.initDrawSearchAreas();
        this.map.fitBounds(this.bounds);
    };
    MapPlugin.prototype.calcBounds = function (coordinates) {
        if (this.bounds) {
            this.bounds.extend(coordinates);
        }
        else {
            this.bounds = L.latLngBounds(coordinates); // Instantiate LatLngBounds object
        }
    };
    MapPlugin.prototype.notifyQuery = function (sparnaturalQuery) {
        this.sparnaturalQuery = sparnaturalQuery;
    };
    MapPlugin.prototype.notifyConfiguration = function (specProvider) {
        this.specProvider = specProvider;
    };
    MapPlugin.prototype.searchCoordinatesOnQuery = function (data) {
        var result = [];
        var iterate = function (obj) {
            if (!obj) {
                return;
            }
            Object.keys(obj).forEach(function (key) {
                var value = obj[key];
                if (typeof value === "object" && value !== null) {
                    iterate(value);
                    if (value.coordinates) {
                        result.push(value);
                    }
                }
            });
        };
        iterate(data);
        return result;
    };
    MapPlugin.prototype.initDrawSearchAreas = function () {
        if (this.map == null || this.sparnaturalQuery == null) {
            return false;
        }
        else {
            var searchareas = this.searchCoordinatesOnQuery(this.sparnaturalQuery);
            var arrayPolygones = [];
            for (var i = 0; i < searchareas.length; i++) {
                var coordonnees = searchareas[i].coordinates[0];
                var latlongs = [];
                for (var ic = 0; ic < coordonnees.length; ic++) {
                    var latLon = [coordonnees[ic].lat, coordonnees[ic].lng];
                    latlongs.push(latLon);
                }
                arrayPolygones.push(latlongs);
            }
            this.drawSearchAreas(arrayPolygones);
        }
    };
    MapPlugin.prototype.drawSearchAreas = function (searchareas) {
        if (this.map == null || this.sparnaturalQuery == null) {
            return false;
        }
        for (var i = 0; i < searchareas.length; i++) {
            this.drawSearchPoly(searchareas[i]);
        }
    };
    MapPlugin.prototype.drawSearchPoly = function (feature) {
        if (!this.map)
            throw Error("Wanted to draw Polygon but no map found");
        // configuration of Polygon see: https://leafletjs.com/reference.html#polygon
        var searchedPolygon = {};
        var polyOptions = [];
        polyOptions = this.config.searchedPolygon;
        var poly = new L.Polygon(feature, polyOptions);
        this.layerGroups["searchPoly"]
            ? this.layerGroups["searchPoly"].addLayer(poly)
            : (this.layerGroups["searchPoly"] = L.layerGroup([poly]));
        poly.addTo(this.map).bringToBack();
        this.calcBounds(feature);
    };
    MapPlugin.prototype.drawMarker = function (feature, variabel, popUpString) {
        var latLng = new L.LatLng(feature.coordinates[1], feature.coordinates[0]);
        if (!this.map)
            throw Error("Wanted to draw Marker but no map found");
        var markerOptions = {
            // markerIcon is the global variable initialized with dynamic import
            icon: markerIcon,
        };
        if (this.config.markerOptions)
            markerOptions = this.config.markerOptions;
        var marker = new L.Marker(latLng, markerOptions).bindPopup(popUpString);
        this.addToLayerList(marker);
        //if clustering is activated, then don't draw the marker but gather it in the cluster
        this.markerCluster.addLayer(marker);
        this.calcBounds(latLng);
    };
    MapPlugin.prototype.drawLineString = function (feature, variable, popUpString) {
        if (!this.map)
            throw Error("Wanted to draw LineString but no map found");
        // Convert GeoJSON coordinates [lng, lat] to Leaflet LatLng [lat, lng]
        var latLngs = feature.coordinates.map(function (coord) { return new L.LatLng(coord[1], coord[0]); });
        var polylineOptions = {};
        if (this.config.polylineOptions)
            polylineOptions = this.config.polylineOptions;
        polylineOptions["color"] = this.config.lineDefaultColor;
        polylineOptions["weight"] = this.config.lineDefaultWeight;
        polylineOptions["opacity"] = 0.7;
        var polyline = new L.Polyline(latLngs, polylineOptions).bindPopup(popUpString);
        this.addToLayerList(polyline);
        polyline.addTo(this.map);
        this.calcBounds(polyline.getBounds());
    };
    MapPlugin.prototype.drawMultiLineString = function (feature, variable, popUpString) {
        if (!this.map)
            throw Error("Wanted to draw MultiLineString but no map found");
        var polylineOptions = {};
        if (this.config.polylineOptions)
            polylineOptions = this.config.polylineOptions;
        polylineOptions["color"] = this.config.lineDefaultColor;
        polylineOptions["weight"] = this.config.lineDefaultWeight;
        polylineOptions["opacity"] = 0.7;
        // Leaflet's L.GeoJSON handles MultiLineString natively
        var geoJsonLayer = L.geoJSON({ type: "Feature", geometry: feature, properties: {} }, {
            style: function () { return polylineOptions; },
            onEachFeature: function (_feature, layer) {
                layer.bindPopup(popUpString);
            },
        });
        this.addToLayerList(geoJsonLayer);
        geoJsonLayer.addTo(this.map);
        this.calcBounds(geoJsonLayer.getBounds());
    };
    MapPlugin.prototype.drawPoly = function (feature, colIndex, popUpString, layerIndex) {
        if (!this.map)
            throw Error("Wanted to draw Polygon but no map found");
        // configuration of Polygon see: https://leafletjs.com/reference.html#polygon
        var polyOptions = {};
        if (this.config.polylineOptions)
            polyOptions = this.config.polylineOptions;
        if (this.colorsUsed.includes(colIndex)) {
            polyOptions["color"] =
                this.config.polygonColors[this.colorsUsed.indexOf(colIndex)];
        }
        else {
            this.colorsUsed.push(colIndex);
            polyOptions["color"] =
                this.config.polygonColors[this.colorsUsed.indexOf(colIndex)];
        }
        //polyOptions['color'] = 'red';
        polyOptions["fill"] = true; // no color filled in polygon
        polyOptions["opacity"] = 0.4; // stroke opacity
        polyOptions["fillOpacity"] = 0.05; // background opacity
        polyOptions["weight"] = this.config.polygonWeight || 1; // stroke width
        // Reverse [lng, lat] to [lat, lng] for all rings not only coordinates[0]
        for (var _i = 0, _a = feature.coordinates; _i < _a.length; _i++) {
            var ring = _a[_i];
            ring.map(function (item) {
                item.reverse();
            });
        }
        var poly = new L.Polygon(feature.coordinates, polyOptions).bindPopup(popUpString);
        this.addToLayerList(poly);
        this.addToLayerGroup(colIndex, poly, layerIndex);
        poly.addTo(this.map);
        this.calcBounds(feature.coordinates[0]);
    };
    MapPlugin.prototype.addIriClickListener = function (el) {
        var iriElements = el.getElementsByClassName("iri");
        var _loop_1 = function (i) {
            var el_1 = iriElements[i];
            el_1.addEventListener("click", function () {
                el_1.dispatchEvent(new CustomEvent("YasrIriClick", { bubbles: true, detail: el_1.text }));
            });
        };
        for (var i = 0; i < iriElements.length; i++) {
            _loop_1(i);
        }
    };
    // Add the drawable to a control layer
    MapPlugin.prototype.addToLayerGroup = function (colIndex, feature, layerIndex) {
        var _a;
        if (layerIndex === void 0) { layerIndex = null; }
        var cols = (_a = this.results) === null || _a === void 0 ? void 0 : _a.getVariables();
        if (cols) {
            var vName = cols[colIndex];
            if (layerIndex != null) {
                vName = cols[colIndex] + "_" + layerIndex;
            }
            this.layerGroups[vName]
                ? this.layerGroups[vName].addLayer(feature)
                : (this.layerGroups[vName] = L.layerGroup([feature]));
        }
    };
    MapPlugin.prototype.createPopUpString = function (row) {
        var _a;
        var popUp = {};
        var columns = (_a = this.results) === null || _a === void 0 ? void 0 : _a.getVariables();
        for (var key in row) {
            var cell = row[key];
            if (this.isBindingValue(cell) &&
                !this.config.geoDataType.includes(cell.datatype) &&
                columns) {
                // store the whole cell in the popup
                popUp[key] = cell;
            }
        }
        var contentString = "";
        for (var _i = 0, _b = Object.entries(popUp); _i < _b.length; _i++) {
            var _c = _b[_i], k = _c[0], cell = _c[1];
            var currentString = "<strong>".concat(k, "</strong>:&nbsp;");
            // normal URI : a clickable URI
            if (cell.type === "uri") {
                currentString += " <a class='iri' style=\"cursor: pointer; color:blue;\" href=\"".concat(cell.value, "\" target=\"_blank\">").concat(cell.value, "</a>");
                // TableXResult special case containing URI + label : clickable URI with label displayed
            }
            else if (cell.type === "x-labelled-uri") {
                currentString += " <a class='iri' style=\"cursor: pointer; color:blue;\" href=\"".concat(cell.value, "\" target=\"_blank\">").concat(cell.label, "</a>");
                // other case : just print the value (the literal)
            }
            else {
                currentString += "".concat(cell.value);
            }
            currentString += "<br />";
            contentString += currentString;
        }
        return contentString;
    };
    MapPlugin.prototype.createMap = function () {
        // Create the map HTMLElement
        var _this = this;
        // Append map to YASR result HTMLElement and init
        var parentEl = document.getElementById("resultsId1");
        if (!parentEl)
            throw Error("Couldn't find parent element of Yasr. No element found with Id: resultsId1");
        if (this.haveResultWithoutGeo > 0) {
            this.warnEL = document.createElement("div");
            this.warnEL.setAttribute("id", "yasrmap-warnEL");
            this.warnEL.setAttribute("class", "alert alert-warning");
            var text = this.config.L18n.warnFindNoCoordinate.replace("<count>", this.haveResultWithoutGeo.toString());
            this.warnEL.innerText = text;
            parentEl.appendChild(this.warnEL);
            var linkToTable = document.createElement("a");
            linkToTable.classList.add("link", "ms-2");
            linkToTable.setAttribute("style", "cursor: pointer;");
            linkToTable.innerText = this.config.L18n.warnFindNoCoordinateBtn;
            this.warnEL.appendChild(linkToTable);
            linkToTable.addEventListener("click", function () {
                _this.yasr.selectPlugin("table");
                return false;
            });
        }
        // Create the map HTMLElement
        this.mapEL = document.createElement("div");
        this.mapEL.setAttribute("id", "yasrmap");
        this.mapEL.style.height = this.config.mapSize.height;
        this.mapEL.style.width = this.config.mapSize.width;
        if (!parentEl)
            throw Error("Couldn't find parent element of Yasr. No element found with Id: resultsId1");
        parentEl.appendChild(this.mapEL);
        this.map = L.map("yasrmap").setView(this.config.setView.center, this.config.setView.zoom, this.config.setView.options);
        if (this.map != null) {
            this.map.options.maxZoom = 19; // see: https://github.com/Leaflet/Leaflet.markercluster/issues/611
        }
        // For each provided baseLayer create a tileLayer and add it to control
        this.config.baseLayers.map(function (l, index) {
            var _a;
            var name = "No attribution name provided";
            if ((_a = l.options) === null || _a === void 0 ? void 0 : _a.attribution)
                name = l.options.attribution;
            var layer = L.tileLayer(l.urlTemplate, l.options);
            if (index === 0 && _this.map)
                layer.addTo(_this.map); // set first base layer as active
            //this.controlLayers?.addBaseLayer(layer,name)
        });
    };
    MapPlugin.prototype.getIcon = function () {
        return (0, __1.drawSvgStringAsElement)("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d=\"M408 120C408 174.6 334.9 271.9 302.8 311.1C295.1 321.6 280.9 321.6 273.2 311.1C241.1 271.9 168 174.6 168 120C168 53.73 221.7 0 288 0C354.3 0 408 53.73 408 120zM288 152C310.1 152 328 134.1 328 112C328 89.91 310.1 72 288 72C265.9 72 248 89.91 248 112C248 134.1 265.9 152 288 152zM425.6 179.8C426.1 178.6 426.6 177.4 427.1 176.1L543.1 129.7C558.9 123.4 576 135 576 152V422.8C576 432.6 570 441.4 560.9 445.1L416 503V200.4C419.5 193.5 422.7 186.7 425.6 179.8zM150.4 179.8C153.3 186.7 156.5 193.5 160 200.4V451.8L32.91 502.7C17.15 508.1 0 497.4 0 480.4V209.6C0 199.8 5.975 190.1 15.09 187.3L137.6 138.3C140 152.5 144.9 166.6 150.4 179.8H150.4zM327.8 331.1C341.7 314.6 363.5 286.3 384 255V504.3L192 449.4V255C212.5 286.3 234.3 314.6 248.2 331.1C268.7 357.6 307.3 357.6 327.8 331.1L327.8 331.1z\"/></svg>");
    };
    // cb: parsing function which takes a string and translates it to a geoJSON geometry
    MapPlugin.prototype.parseGeoLiteral = function (row, cb) {
        var geoLiterals = this.getGeosparqlValue(row);
        if (!geoLiterals)
            return [];
        return geoLiterals.map(function (lit) {
            lit.parsedLit = cb(lit.cellValue.value); // let callback do the parsing
            return lit;
        });
    };
    // remove the already rendered map so we can rerender it
    MapPlugin.prototype.cleanUp = function () {
        var _a, _b;
        (_a = this.mapEL) === null || _a === void 0 ? void 0 : _a.remove();
        (_b = this.warnEL) === null || _b === void 0 ? void 0 : _b.remove();
        this.layerGroups = {};
        this.markerCluster = L.markerClusterGroup();
        this.controlLayers = L.control.layers();
        this.colorsUsed = [];
        this.bounds = false;
    };
    MapPlugin.prototype.addToLayerList = function (g) {
        this.layers.push(g);
    };
    // see: https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards
    MapPlugin.prototype.isBindingValue = function (cell) {
        if (cell === "")
            return false;
        if (typeof cell === "number")
            return false;
        return "value" in cell && ("type" in cell || "datatype" in cell);
    };
    MapPlugin.prototype.polygonArea = function (coords) {
        var total = 0;
        var arrayCoords = new Array();
        arrayCoords[0] = new Array();
        var index = 0;
        coords[0].forEach(function (point) {
            var newSet = [point[0], point[1]];
            arrayCoords[0][index] = newSet;
            index++;
        });
        if (arrayCoords && arrayCoords.length > 0) {
            total += Math.abs(this.ringArea(arrayCoords[0]));
            for (var i = 1; i < arrayCoords.length; i++) {
                total -= Math.abs(this.ringArea(arrayCoords[i]));
            }
        }
        return Math.round(total);
    };
    MapPlugin.prototype.ringArea = function (coords) {
        var coordsLength = coords.length;
        var earthRadius = 6371008.8 / 1000; //km²
        var FACTOR = (earthRadius * earthRadius) / 2;
        var PI_OVER_180 = Math.PI / 180;
        if (coordsLength <= 2)
            return 0;
        var total = 0;
        var i = 0;
        while (i < coordsLength) {
            var lower = coords[i];
            var middle = coords[i + 1 === coordsLength ? 0 : i + 1];
            var upper = coords[i + 2 >= coordsLength ? (i + 2) % coordsLength : i + 2];
            var lowerX = lower[0] * PI_OVER_180;
            var middleY = middle[1] * PI_OVER_180;
            var upperX = upper[0] * PI_OVER_180;
            total += (upperX - lowerX) * Math.sin(middleY);
            i++;
        }
        return total * FACTOR;
    };
    // define the default config for leaflet
    MapPlugin.defaults = {
        baseLayers: [
            {
                urlTemplate: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                options: {
                    maxZoom: 19,
                    attribution: "© OpenStreetMap",
                },
            },
        ],
        geoDataType: [
            "http://www.opengis.net/ont/geosparql#wktLiteral",
            "http://www.openlinksw.com/schemas/virtrdf#Geometry",
        ],
        polylineOptions: null,
        markerOptions: null,
        polygonDefaultColor: "blue",
        lineDefaultColor: "red",
        lineDefaultWeight: 3,
        polygonColors: ["black", "green", "orange", "blue", "purple", "red"],
        polygonWeight: 1,
        searchedPolygon: {
            fillColor: "transparent",
            weight: 2,
            opacity: 1,
            color: "gray",
            dashArray: "10",
            fillOpacity: 0,
        },
        mapSize: {
            width: "auto",
            height: "550px",
        },
        setView: {
            center: [46.20222, 6.14569],
            zoom: 11,
            options: undefined,
        },
        parsingFunction: wktParsing_1.wktToGeoJson,
        L18n: {
            warnFindNoCoordinate: "Attention, des résultats (<count>) n'ont pas de coordonnées pour être représentés sur la carte.",
            warnFindNoCoordinateBtn: "Afficher la table des résultats",
        },
    };
    return MapPlugin;
}());
exports.MapPlugin = MapPlugin;
